module.exports = __webpack_public_path__ + "customer-portal.svg?43685ae41f70fc08b8433f6e0dce0008";